module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAABE0lEQVQ4jY2SLUtEURCGH68fRXGTgmAxm2Vlg2ASLBst+wPEaN0q+hdMgkWDXYPBvCBokjUYBVlBQTQpPIb1wnE897ovnDDzznPOMGdQSU5D7ao99UV9Va/VPXU+rU2hdXVgtd7UdgSbNUDUhsqYCjAA5hhNn8BMAWxmoHNgDWgBZ8GbBDqoR6GV2zAw1KtQc1IAC+HG00x7xyGeLYB+SK5kwGaIn1BXM5PbTtrsZPx2afYz5r16l8k/m/zjcqagSi3D5myNAO2YWTnUgxro0IpdLc9lBrqJdeXKpZoG3kNuEXhME0Xmzz6A3STejxCQfbHUFzAOTDFc7F+aqKKA3k+Lf6D/wAugUWXWtbrEcAYPOfMbctsV0g9HysMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/location-icon.png
// module id = 286
// module chunks = 0